/**
 * Horario laboral para tracking GPS del vendedor (hora local del dispositivo).
 *
 * REACT_APP_GPS_START / REACT_APP_GPS_END = "HH:MM" (24h). Default 08:00–20:00.
 *
 * Excepción: con visita abierta o pedido en curso, el GPS sigue hasta cerrar
 * (aunque sea 20:05). Luego se detiene hasta la siguiente ventana laboral.
 *
 * En APK Android, el servicio en segundo plano / notificación usa la misma lógica.
 */

const DEFAULT_START = '08:00';
const DEFAULT_END = '20:00';

function parseHm(raw, fallback) {
  const s = String(raw || fallback).trim();
  const m = /^(\d{1,2}):(\d{2})$/.exec(s);
  if (!m) return parseHm(fallback, '08:00');
  const h = Number(m[1]);
  const min = Number(m[2]);
  if (!Number.isFinite(h) || !Number.isFinite(min) || h < 0 || h > 23 || min < 0 || min > 59) {
    return parseHm(fallback, '08:00');
  }
  return { h, min, label: `${String(h).padStart(2, '0')}:${String(min).padStart(2, '0')}` };
}

export const GPS_WORK_START = parseHm(process.env.REACT_APP_GPS_START, DEFAULT_START);
export const GPS_WORK_END = parseHm(process.env.REACT_APP_GPS_END, DEFAULT_END);

/** Minutos desde medianoche local. */
export function localMinutesNow(date = new Date()) {
  return date.getHours() * 60 + date.getMinutes();
}

function toMinutes({ h, min }) {
  return h * 60 + min;
}

/**
 * ¿Estamos dentro de la ventana laboral (idle)?
 * Ventana normal (start < end): [start, end).
 * Ventana que cruza medianoche (start > end): [start, 24h) U [0, end).
 * start === end: nunca activo (configuración inválida / deshabilitado).
 */
export function isWithinGpsWorkWindow(date = new Date()) {
  const now = localMinutesNow(date);
  const start = toMinutes(GPS_WORK_START);
  const end = toMinutes(GPS_WORK_END);
  if (start === end) return false;
  if (start < end) return now >= start && now < end;
  return now >= start || now < end;
}

/**
 * Tracking activo si: ventana laboral O visita/pedido en curso.
 * @param {{ forceActive?: boolean, date?: Date }} [opts]
 */
export function shouldTrackGps(opts = {}) {
  if (opts.forceActive) return true;
  return isWithinGpsWorkWindow(opts.date || new Date());
}

export function gpsWorkWindowLabel() {
  return `${GPS_WORK_START.label}–${GPS_WORK_END.label}`;
}
